<script setup>
import Icon from 'next/icon/Icon.vue';

defineProps({
  label: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  // null = título fixo; true/false = seção recolhível, aberta ou fechada.
  aberto: {
    type: Boolean,
    default: null,
  },
});
</script>

<template>
  <div
    class="flex items-center gap-2 px-2 py-1.5 rounded-lg h-8 text-n-slate-10 select-none pointer-events-none"
  >
    <Icon v-if="icon" :icon="icon" class="size-4" />
    <span class="text-sm font-medium leading-5 flex-grow">
      {{ label }}
    </span>
    <span
      v-if="aberto !== null"
      class="i-lucide-chevron-right size-4 shrink-0 transition-transform duration-200"
      :class="{ 'rotate-90': aberto }"
    />
  </div>
</template>
